module.exports = __webpack_public_path__ + "static/img/industry2.700771e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry2.png
// module id = NoHk
// module chunks = 2